import { useAssetFilter } from '../../assets';
import { getWorkspaceFilter } from '../../auth';
import { ActivityFilterModel } from './activityFilterModel';

export const getActivityFilter = (
  filter: ActivityFilterModel,
  workspaceId?: string,
  assetId?: string,
  /**
   * Whether this viewer gets the aggregated campaign card on the main feed
   * (i.e. holds `campaign.read`). Defaults to `true` so legacy callers keep the
   * original "always hide inline CAMPAIGN issues" behavior.
   */
  surfaceCampaignsAsCards = true
) => {
  let f = filter?.getFilter() || {};
  f = getWorkspaceFilter(workspaceId, f);
  f = useAssetFilter(assetId, f);
  // Main feed only. Campaign activity surfaces one of two ways:
  //  - Viewers with `campaign.read` get the aggregated campaign card, so the
  //    raw CAMPAIGN issue rows are hidden here to avoid double-counting.
  //  - Viewers without it (e.g. Restricted) get no card, so the CAMPAIGN issues
  //    show inline as ordinary rows — group-gated by findIssues, exactly like
  //    the per-asset feed (which never sets this exclusion).
  // Either way, an OFF Campaigns toggle (marker 'CAMPAIGN' in activityTypes)
  // hides campaign activity entirely.
  if (!assetId) {
    const campaignsToggleOff = (filter?.activityTypes ?? []).includes(
      'CAMPAIGN'
    );
    if (surfaceCampaignsAsCards || campaignsToggleOff) {
      f.excludeActivityTypes = ['CAMPAIGN'];
    }
  }
  return f;
};
